export default {
  name: "modal",
  data() {
    return {
      modalInfo: {
        title: this.$t("warning").capitalize(),
        cancel: this.$t("no").capitalize(),
        ok: this.$t("yes").capitalize(),
        msg: "",
        item: {},
        okOnly: false,
        size: "md",
        popup: false
      },
      modalInfo1: {
        title: this.$t("warning").capitalize(),
        cancel: this.$t("no").capitalize(),
        ok: this.$t("yes").capitalize(),
        msg: "",
        item: {},
        okOnly: false,
        size: "md",
        popup: false
      },
      modalInfo2: {
        title: this.$t("warning").capitalize(),
        cancel: this.$t("no").capitalize(),
        ok: this.$t("yes").capitalize(),
        msg: "",
        item: {},
        okOnly: false,
        size: "md",
        popup: false
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/modal.js
// module id = vKRF
// module chunks = 18